import { useState } from 'react';
import Chip, { type IChipProps } from '../../atoms/Chip';
import Preloader from '../../atoms/Preloader';
import type { IFileData } from '../../types/IFileData';
import clsx from 'clsx';
import { downloadWithLoading } from '../../lib/download';
import { useUi } from '../../provider/UiContext';

import './Attachment.scss';

export interface IAttachmentProps extends Omit<IChipProps, 'children' | 'onRemove'> {
    /** Список вложенных файлов */
    attachment?: IFileData;
    /** Показывать иконку удаления
     * @default true
     */
    showRemoveIcon?: boolean;
    /** Функция удаления файла */
    onRemove?: (file: IFileData) => void;
    /** Класс */
    className?: string;
}

const Attachment = ({ attachment, showRemoveIcon = true, onRemove, className, ...props }: IAttachmentProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { notify } = useUi();

    if (!attachment) {
        return null;
    }

    return (
        <div className={clsx('rf-attachment', className)}>
            {isLoading && (
                <div className="rf-attachment__loader">
                    <Preloader size={16} />
                </div>
            )}

            <Chip
                onClick={() =>
                    downloadWithLoading(attachment, setIsLoading, () =>
                        notify({ message: 'Файл не обнаружен.', variant: 'red' }),
                    )
                }
                size="sm"
                variant="outline"
                maxLength={30}
                tooltipBackground={'white'}
                onRemove={showRemoveIcon ? () => onRemove?.(attachment) : undefined}
                removeLabel={`Удалить «${attachment.file.name}»`}
                iconPosition="right"
                {...props}
            >
                {attachment.file.name}
            </Chip>
        </div>
    );
};

export default Attachment;
